import styled from 'styled-components';
import { theme } from '../../theme';

export const TabHeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  :hover {
    cursor: pointer;
  }
`;

export const TabHeaderItemWrapper = styled.div<{ selected: boolean; disabled?: boolean }>`
  height: 30px;
  display: flex;
  justify-content: center;
  flex: 1 0 auto;
  border-radius: 10px 10px 0px 0px;
  color: ${(p) => (p.selected ? theme.palette.common.white : theme.palette.primary.light)};
  background-color: ${(p) => (p.selected ? theme.palette.secondary.light : theme.palette.common.white)};
`;

export const TabBodyWrapper = styled.div<{ firstSelected: boolean; lastSelected: boolean }>`
  border-radius: ${(p) =>
    p.firstSelected && p.lastSelected
      ? '0 0 10px 10px'
      : p.firstSelected
      ? '0 10px 10px 10px'
      : p.lastSelected
      ? '10px 0 10px 10px'
      : '10px'};
  display: flex;
  flex-direction: column;
  border: 2px solid ${() => theme.palette.secondary.light};
  padding: 10px;
`;

export const TabHeaderItemCurl = styled.div`
  position: relative;
  width: 20px;
  height: 30px;
  background-color: ${() => theme.palette.secondary.light};
`;

export const TabHeaderItemCurlMask = styled.div<{ direction: 'left' | 'right' | 'none' }>`
  position: absolute;
  background-color: ${() => theme.palette.common.white};
  width: 20px;
  height: 30px;
  border-radius: ${(p) => (p.direction !== 'none' ? (p.direction === 'left' ? '0 0 0 10px' : '0 0 10px 0') : '0')};
`;
